import { Dialog } from "./function-call";
var stdin_default = Dialog;
export {
  Dialog,
  stdin_default as default
};
